/**
 * @file common
 *
 * Javascript docs : http://usejsdoc.org/
 */

/**
 *
 * @param reCaptchaPubKey
 * @param id
 */
function createReCaptcha(reCaptchaPubKey, id) {
    Recaptcha.create(reCaptchaPubKey, id, {
        theme: "clean",
        custom_translations: {
            instructions_visual: ACC.instructionsVisualReCaptcha
        }
    });
}

jQuery(document).ready(function () {
    bindCreateUpdateAddress();
    jQuery("#submitForgottenPassword").on('click', function (event) {
        event.preventDefault();
        jQuery("#messageErrors").html('');
        jQuery.ajax({
            type: "POST",
            data: jQuery("#ForgottenPassword").serialize(),
            url: jQuery("#ForgottenPassword").attr('action') + "/validate"
        }).done(function (data) {
            if (data == "OK") {
                jQuery("#ForgottenPassword").trigger('submit');
            } else {
                jQuery("#messageErrors").html(data);
            }
        }).fail(function () {
            jQuery("#messageErrors").html('Sorry, an error has occured');
        });
    });

    jQuery("#btn-mood").on('click', function () {
        /**
         *
         * @type {*|jQuery}
         */
        var op1 = $('#select-humeur').val(),
            op2 = $('#select-produit').val(),
            op3 = $('#select-pour').val();
        if (op1 == "" || op2 == "" || op3 == "") {
            /**
             *
             * @type {string}
             */
            var selectModal = '#ModalMoodSearch';
            $(selectModal).show();
            $(selectModal).modal();
        }
    });

    jQuery(document).ready(function ($) {
        $('#addDocLanguage').closest('form').trigger('submit');
    });

    $('#addDocSelector').on('submit', function (e) {
        e.preventDefault();
        jQuery.ajax({
            data: $('#addDocSelector').serialize(),
            url: $('#addDocSelector').attr('action'),
        }).done(function (html) {
            $("#ScrollProductDoc").html(html);
            //Analytic.bindAllEvents($("#ScrollProductDoc"));
        });
    });
    displyClaimDisclaimer();

    var $container = $("html,body");
    var $scrollTo = $('.c-product-detail__bundle-row');
    setTimeout(function () { 
        $container.animate({scrollTop: $scrollTo.offset().top -20 , scrollLeft: 0},300); 
    }, 1500);
});

/**
 *
 */
function displyClaimDisclaimer() {
    $(function () {
        $(".claim").tooltip({
            track: true,
            items: "p",
            content: function () {
                /**
                 *
                 * @type {*|jQuery}
                 */
                var claimDisclaimer = $(this).closest(".main-claim").find("div.claim-disclaimer").text();
                return claimDisclaimer;
            },
            show: {
                effect: "slideDown",
                delay: 250
            }
        });
    });
}

$('#addDocLanguage').on('change', function () {
    $(this).closest('form').trigger('submit');
});

/** reapply style after dom content load */
$(function () {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var elem = $('.side-menu-level2');
    elem.on('click', reapplyStyle);
});

/**
 *
 */
function reapplyStyle() {
    /**
     *
     * @type {*|jQuery|HTMLElement}
     */
    var elems = $('.with-pic');
    elems.each(function () {
        /**
         *
         * @type {*|jQuery|HTMLElement}
         */
        var that = $(this);
        that.removeClass('with-pic');
        that.addClass('with-pic');
    });
    console.log('Done.');
}
/** reapply style after dom content load end*/

/* REPARABILITY PAGE */
//Autocomplete show widget Search
$(".search-area-reparability .search form #search-filter_reparability").autocomplete().autocomplete("widget").appendTo('.search-area-reparability .search');

document.addEventListener("DOMContentLoaded", function () {
    /**
     *
     * @type {Element}
     */
    var element = document.getElementById("search-filter_reparability");
    if (element != null) {
        element.oninvalid = function (e) {
            e.target.setCustomValidity("");
            if (!e.target.validity.valid) {
                e.target.setCustomValidity(reparabilityValideMessage);
            }
        };
        element.oninput = function (e) {
            e.target.setCustomValidity("");
        };
    }
});

/* END REPARABILITY PAGE */

/* BEGIN | BRA-5286 : NewsletterSubscriptionComponent */

/**
 *
 */
function isValidEmailAddress() {
    /**
     *
     * @type {*|jQuery}
     */
    var emailAddress = $("#email").val();

    /**
     *
     * @type {RegExp}
     */
    var pattern = new RegExp('[-0-9a-zA-Z.+_]+@[-0-9a-zA-Z.+_]+\.[a-zA-Z]{2,4}');
    if (pattern.test(emailAddress)) {
        $("#companionEmailError").hide();
        $("#companionClubForm").trigger('submit');
    }
    else {
        $("#companionEmailError").show();
    }
}

jQuery("#companionClubForm").on('submit',
    function (event) {
        /**
         *
         */
        var baseURL = jQuery("#companionClubForm").attr('action');
        jQuery("#messageErrors").html('');
        jQuery("#messageSuccess").html('');
        event.preventDefault();
        jQuery.ajax({
            type: "POST",
            data: jQuery("#companionClubForm").serialize(),
            url: baseURL
        }).done(function (data) {
            if (data.success == true) {
                $('#newLetterSubsModal').modal('show');
                $(".modal-body").html(data.message);
                $('.modal').on('hidden.bs.modal', function () {
                    $.clearFormFields($("#companionClubForm"));
                });
            } else {
                $('#newLetterSubsModal').modal('show');
                jQuery("#messageErrors").text(data.message);
                $(".modal-body").html(data.message);
                $('.modal').on('hidden.bs.modal', function () {
                    $.clearFormFields($("#companionClubForm"));
                });
            }
        }).fail(function () {
            jQuery("#messageErrors").text(data.message);
            $('#newLetterSubsModal').modal('show');
            $('.modal').on('hidden.bs.modal', function () {
                $.clearFormFields($("#companionClubForm"));
            });
        });
    });

$.clearFormFields = function (area) {
    $(area).find('input[type="text"]').val('');
};

/* END | BRA-5286 : NewsletterSubscriptionComponent */



///BRA-6165: Griser le bouton submit du formulaire de création de compte après validation
$("#FormCreateProfile").on("submit", function (e) {
    $(this).find("button.btn-action").attr("disabled", "disabled");
});

//BRA-6332: Auto-complete exploded view
$(document).ready(function () {
    // autocomplete detached Pieces
    /**
     *
     * @type {*|jQuery}
     */
    var productCode = $("#detachedPieceForm #productCode").val();
    $(function () {
        $("#detachedPieceForm #accessoryCode").autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: ACC.config.contextPath + "/exploded-view/" + productCode + "/detail-exp-view/auto-compelte",
                    type: "GET",
                    dataType: "json",
                    data: {term: request.term}
                }).done(function (data) {
                    console.log(data);
                    response(data);
                });
            }
        });
    });
});

/* BRA-5659 : Start*/
function checkRightToDeletAccount(element,event,checkCart) {
	var urlValidation = $($(element)).attr('data');
	var params = {"checkCart": checkCart};
	$.ajax({
        url: urlValidation, async: false, data:params
    }).done(function (data) {
        if(data == "CART_IN"){
            $("#ModalRemoveCart").show();
            $("#ModalRemoveCart").modal();
        }else if (data == 'NOK') {
        	event.preventDefault();
            $("#ModalBlockDeleteAccount").show();
            $("#ModalBlockDeleteAccount").modal();
        }else if(data == 'OK'){
        	event.preventDefault();
            $("#ModalDeleteAccount").show();
            $("#ModalDeleteAccount").modal();
        }

    }).fail(function (data) {
    	event.preventDefault();
    	console.log("Error in validing account deletion !");
    });
}
/* BRA-5659 : END*/


$(function () {
    if ($('.page-MobileApplicationListPage')) {
        $('.our-applications  .our-applications-listing-item .our-applications-listing-compatibility p span').on('click', function (e) {
            e.preventDefault();
            var index = $(this).data('our-app-index');
            console.log(index);
            $('#mobileapp-compatibility-popin-' + index).modal();
            Modal.show();
        });
    }
});

jQuery(document).ready(function() {

	//Display offers popin
    if($(".offer-popin").length) {
        var displayTimeout = $(".offer-popin").data("timeout") * 1000;
        setTimeout(function () {
            $(".offer-popin").modal();
            Modal.show();
        }, displayTimeout);
    }
    //Display offers popin
});

jQuery(document).ready(function ($) {
	if ($('#newLetterSubsModal').length > 0 ) {
    	$("#newLetterSubsModal").insertAfter($('#ModalMessage'));
    }
});

$(document).ready(function () {
	if($(window).width() > 720){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});

$(window).on('resize', function () {
	if($(window).width() > 720){
		var marginLeft = -($(".offer-popin").width())/2;
		$(".offer-popin").css("margin-left",marginLeft);
	}
	else{
		$(".offer-popin").css("margin-left","");
	}
});

